import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import { useNameColumn } from "../../Table/useColumns/useNameColumn";
import { useEmployeeNumberColumn } from "../../Table/useColumns/useEmployeeNumberColumn";
import { usePayGroupColumn } from "../../Table/useColumns/usePayGroupColumn";
import { useGroupColumns } from "../../Table/useColumns/useGroupColumns";
import { useLocationsColumn } from "../../Table/useColumns/useLocationsColumn";
import { useJobsColumn } from "../../Table/useColumns/useJobsColumn";
import { usePaymentColumn } from "../../Table/useColumns/usePaymentColumn";
import { useEarningGroupsColumns } from "../../Table/useColumns/useEarningGroupsColumns";
import { useRetroAmountColumn, useRetroHoursColumn } from "../../Table/useColumns/useRetroColumn";
import { useConfigurationModule } from "../../../../Settings/Configuration/hooks/useConfigurationModule";

export const useColumns = ({ response, loading, canViewRates }) => {
    const { t } = useTranslation();
    const hideRetroAdjustment = useConfigurationModule("timeSheetGeneral.hideRetroAdjustment");

    const nameColumn = useNameColumn({ viewProfile: undefined });
    const employeeNumberColumn = useEmployeeNumberColumn();
    const payGroupColumn = usePayGroupColumn();
    const groupColumns = useGroupColumns();
    const locationsColumn = useLocationsColumn();
    const jobsColumn = useJobsColumn();
    const earningGroupsColumns = useEarningGroupsColumns();

    const paymentColumn = usePaymentColumn();

    const retroAmountColumn = useRetroAmountColumn();
    const retroHoursColumn = useRetroHoursColumn();

    return useMemo(() => {
        const columns = [
            nameColumn,
            employeeNumberColumn,
            payGroupColumn,
            ...groupColumns,
            locationsColumn,
            jobsColumn,
            ...earningGroupsColumns,
        ];
        if (!hideRetroAdjustment) {
            columns.push(retroHoursColumn);
        }
        if (canViewRates) {
            if (!hideRetroAdjustment) {
                columns.push(retroAmountColumn);
            }
            columns.push(paymentColumn);
        }
        columns.push({
            Header: t("status"),
            accessor: "message",
            Cell: ({
                row: {
                    original: { id },
                },
            }) => {
                return response ? (
                    <span
                        className={classNames(
                            response[id]?.status
                                ? "text-green"
                                : "text-danger",
                        )}
                    >
                        {response[id]?.message}
                    </span>
                ) : loading ? (
                    `${t("copying")}...`
                ) : (
                    t("ready-to-copy")
                );
            },
        });
        return columns;
    }, [
        nameColumn,
        employeeNumberColumn,
        payGroupColumn,
        groupColumns,
        locationsColumn,
        jobsColumn,
        earningGroupsColumns,
        retroHoursColumn,
        paymentColumn,
        retroAmountColumn,
        response,
        loading,
        t,
        canViewRates,
        hideRetroAdjustment
    ]);
}